// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reset-request ftr-portal-badge {
    display: flex;
    justify-content: center;
  }

.reset-request h1 {
    margin-bottom: calc(.5rem);
    text-align: center;
  }

.reset-request__instructions {
    font-size: 0.875rem;
    line-height: 1.375rem;
    padding-top: calc(2rem);
    text-align: center;
  }
`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
